<template>
  <div class="animated fadeIn">
    <b-row class="cert-row">
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong v-show="currentQuickQualification.result_code !== 'A'" class="certificate-heading">{{ $t('messages.moreInfoNeeded') }}</strong>
            <strong v-show="currentQuickQualification.result_code === 'A'" class="certificate-heading">{{ $t('messages.preApprovalCertificate') }}</strong>
            <b-button v-show="currentQuickQualification.result_code === 'A'" @click="print" class="pull-right"><i class="fa fa-print"></i> <span class="d-none d-sm-inline"> {{ $t('messages.print') }}</span></b-button>
          </div>
          <b-row v-show="currentQuickQualification.result_code !== 'A' && currentQuickQualification.has_ssn === true">
            <b-col sm="12">
              <p>{{ $t('messages.stillNeedMoreInfo') }}:</p>
              <h3>{{ currentQuickQualification.client.name }}</h3>
              <p>{{ currentQuickQualification.lead_twilio_number | phone }}<br>
                {{ currentQuickQualification.client.address }}
                {{ currentQuickQualification.client.address_2 }}<br>
                {{ currentQuickQualification.client.city }}
                {{ currentQuickQualification.client.state }},
                {{ currentQuickQualification.client.postal_code }}
              </p>
            </b-col>
          </b-row>
          <b-row v-show="currentQuickQualification.result_code !== 'A' && currentQuickQualification.has_ssn === false">
            <b-col sm="12">
              <p>{{ currentQuickQualification.first_name }}, {{ $t('messages.moreInfo') }}:</p>
              <b-form @submit.prevent="submit">
                    <b-form-group :label="`${$t('messages.socialSecurityNumber')}*`" description="ex. 999-99-9999">
                      <b-input-group>
                        <masked-input
                          type="tel"
                          @keypress="isNumber($event, 'applicant.ssn')"
                          name="applicant.ssn"
                          v-validate="{
                            required: true,
                            regex: /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/
                          }"
                          :class="{
                            'form-control': true,
                            'is-valid': validateState('applicant.ssn') === true,
                            'is-invalid': validateState('applicant.ssn') === false,
                          }"
                          v-model="applicant.ssn"
                          :mask="[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                          :guide="true"
                          placeholderChar="#">
                        </masked-input>
                      </b-input-group>
                    </b-form-group>

                    <b-button
                      :disabled="!isComplete || veeErrors.any() || submitting"
                      type="submit"
                      size="md"
                      variant="primary">
                      <i class="fa fa-dot-circle-o"></i>
                      {{$t('messages.continue')}}</b-button>
              </b-form>

            </b-col>
          </b-row>
          <b-row v-show="currentQuickQualification.result_code === 'A'">
            <b-col sm="12" class="text-center rainbow">
              <p>{{ $t('messages.thisCertPresentedTo') }}:</p>
              <h1>{{ currentQuickQualification.first_name }} {{ currentQuickQualification.last_name }}</h1>
              <h1>{{ $t('messages.congratulations') }}!</h1>
              <p v-if="!currentQuickQualification.client.soft_pull_hide_score_range">{{ $t('messages.your') }} {{ currentQuickQualification.bureau_name }} {{ $t('messages.scoreRangeIs') }}:</p>
              <h1 v-if="!currentQuickQualification.client.soft_pull_hide_score_range">{{ currentQuickQualification.score_range }}</h1>
              <h2>{{ $t('messages.preApprovedFi') }}</h2>
              <p>{{ $t('messages.validOnlyAt') }}</p>
              <h3>{{ currentQuickQualification.client.name }}</h3>
              <p>{{ currentQuickQualification.client.address }}
                {{ currentQuickQualification.client.address_2 }}<br>
                {{ currentQuickQualification.client.city }}
                {{ currentQuickQualification.client.state }},
                {{ currentQuickQualification.client.postal_code }}
              </p>
              <p>{{ $t('messages.offerExpires') }}: {{ expiresAt }}</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import { mapActions, mapGetters } from 'vuex';
import VueNotifications from 'vue-notifications';
import MaskedInput from 'vue-text-mask';

export default {
  name: 'QuickQualifyResult',
  components: {
    MaskedInput,
  },
  data() {
    return {
      submitting: false,
      ssnTouched: false,
      applicant: {
        guid: this.$route.params.guid,
        ssn:'',
        clientId: this.$route.params.client
      }
    }
  },
  methods: {
    print() {
      window.print();
    },
    ...mapActions({
        patchQuickQualification: 'quickQualify/patchQuickQualification',
    }),
    isNumber(evt, ref) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        if(ref === 'applicant.ssn') {
          this.ssnTouched = true;
        }
        return true;
      }
    },
    submit() {
        this.submitting = true;
        this.patchQuickQualification(this.applicant).then((res) => {
            this.$router.push({ name: 'QuickQualifyResult', params: { guid: res.guid, client: this.$route.params.clientId } });
            this.submitting = false;
        }).catch((err) => {
            this.showErrorMsg();
            this.submitting = false;
        });
    },
    validateState(ref) {
      // mask field act funny
      if (ref === 'applicant.ssn' && !this.ssnTouched) {
          return null;
      }
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      }
      return null
    }
  },
  computed: {
      ...mapGetters({
          currentQuickQualification: 'quickQualify/currentQuickQualification',
      }),
      isComplete() {
          return !!(this.applicant.ssn)
      },
      expiresAt() {
          return DateTime.fromISO(this.currentQuickQualification.expires_at).toFormat('LLL dd, yyyy');
      },

  },
}
</script>

<style lang="scss">
@keyframes rotate {
	100% {
		transform: rotate(1turn);
	}
}

.rainbow {
	position: relative;
	z-index: 0;
	border-radius: 10px;
	overflow: hidden;
	padding: 2rem;

	&::before {
		content: '';
		position: absolute;
		z-index: -2;
		left: -50%;
		top: -50%;
		width: 200%;
		height: 200%;
		background-color: #399953;
		background-repeat: no-repeat;
		background-size: 50% 50%, 50% 50%;
		background-position: 0 0, 100% 0, 100% 100%, 0 100%;
		background-image: linear-gradient(#399953, #399953), linear-gradient(#fbb300, #fbb300), linear-gradient(#d53e33, #d53e33), linear-gradient(#377af5, #377af5);
		animation: rotate 4s linear infinite;
	}

	&::after {
		content: '';
		position: absolute;
		z-index: -1;
		left: 6px;
		top: 6px;
		width: calc(100% - 12px);
		height: calc(100% - 12px);
		background: white;
		border-radius: 5px;
	}
}

@media only screen and (max-width: 767px) {
  .card-footer .btn {
    display: block;
    width: 100%;
  }
}
.button-spacer {
  margin-right: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.certificate-heading {
  line-height: 2.5;
}
</style>
